import { useEffect } from "react";
import * as pollActions from './actions';

export function useUpdateSkippedQuestionList(dispatch, id, isCurrent) {
  useEffect(() => {
    if (isCurrent) {
      dispatch(pollActions.dispatchSkipForAllPrevNonStickyQuestions(id));
    }
  }, [isCurrent]);
};